<template>
  <div class="side-view">
    <div class="graph-view_describe " :style="{width:(language === 'el' ? '110px' : '120px')}">
      <div class="graph-view_availablerange"><span class="graph-view_block"></span><span class="graph-view_text">{{ $t(strColor1) }}</span></div>
      <div class="graph-view_screen"><span class="graph-view_block"></span><span class="graph-view_text">{{ $t(strColor2) }} </span></div>
    </div>
    <div class='graph-view_checkbox'>
      <div class='Projector_checkbox'>
        <van-checkbox v-model='projectorCheckedSide' shape="square"><span>{{$t('T_CHANGE_PJ_POS')}}</span></van-checkbox>
      </div>
    </div>
    <Cv
      id="sideView"
      :w="depthInit"
      :h="heightInit"
      :pjRect="pjImgRect"
      :roomRect="roomRect"
      :arrDashLines="arrDashLines"
      :arrDashRemainLines="arrDashRemainLines"
      :arrOffsetLines="arrOffsetLines"
      :arrRectLines="arrRectLines"
      :arrLightingArea="arrLightingArea"
      :avlRect="avlRect"
      :arrHelpLines="arrHelpLines"
      :arrHelpText="arrHelpText"
      :arrCatchArea="arrCatchArea"
      :arrRectHorSecLines="arrRectHorSecLines"
       @setArrHelpLine="setArrHelpLine"
      ref="sideView"
    >
    </Cv>
    <div class="graph-slider-block" :class="{'hidden':this.vAngleFlag === false}">
      <div class="slider-title-v">{{ $t(sliderTitle) }}</div>
      <div class="slider-content">
        <div class="slider-item">{{ $t(sliderMsg1) }}</div>
        <el-slider
        v-model="vAngleData"
        :max="sliderMax"
        :min="sliderMin"
        :step="0.1"
        vertical
        :height="sliderHeight"
        :disabled="!vAngleFlagData"
        :show-tooltip= false>
        </el-slider>
        <div class="slider-item">{{ $t(sliderMsg2) }}</div>
        <div class="graph-view_slider-input">
          <!-- <inputValidateBox prop='vAngleData' :rules="rules.number"> -->
            <van-field v-model.number="vAngleDataSilder" type="number" :class="{ 'red':isVOut }"  class="side_input" :disabled="!vAngleFlagData"
            @blur="validator($event)"
            @input="testDigitalNegative($event, 'vAngleData')">
              <template slot="right-icon"><span >{{sliderAppend}}</span></template>
            </van-field>
          <!-- </inputValidateBox> -->
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from 'vuex'
// import inputValidateBox from '@/components/inputValidateBox'

export default {
  name: 'sideView',
  data () {
    return {
      title: 'T_SIDE_VIEW',
      greenMsg: 'T_AVAILABLE_RANGE',
      sliderTitle: 'T_ANGLE',
      sliderMsg1: 'T_UP',
      sliderMsg2: 'T_DOWN',
      strColor1: 'T_AVAILABLE_RANGE',
      strColor2: 'T_MSG_OUT_WALL',
      sliderMax: 90,
      sliderMin: -90,
      sliderAppend: '°',
      child: null,

      pjImgRect: {},
      roomRect: {},
      avlRect: {},
      arrDashLines: [],
      arrDashRemainLines: [],
      arrOffsetLines: [],
      arrLightingArea: [],
      arrRectLines: [],
      arrCatchArea: [],
      arrHelpLines: [],
      arrHelpText: [],
      arrRectHorSecLines: [],
      depthInit: 0,
      heightInit: 0,

      helpDisMin: 20,
      helpDisMax: 40,
      helpTextDis: 37,
      helpBesideDis: 45,
      sliderHeight: '0px',
      vAngleDataSilder: 0,
      rules: {
        'number': [
          { required: true, message: '必填' },
          { type: 'number', message: '请输入数字' }
        ]
      },
      vAngleTypeOneArr: ['EB-Z', 'EB-G6', 'EB-G7', 'CB-Z', 'CB-G6', 'CB-G7', 'Pro Z', 'Pro G6', 'Pro G7'],
      isLShaped01: this.$commonViewJs.isLShaped01()
    }
  },

  components: {
    // inputValidateBox
  },

  computed: {
    ...mapState([
      'pjY',
      'pjZ',
      'graph',
      'vAngle',
      'houseInfo',
      'vAngleFlag',
      'hAngleFlag',
      'drawData',
      'lenghProInit',
      'widthProInit',
      'projector_checked_side',
      'offset',
      'dashData',
      'dashFlag',
      'limitData',
      'language',
      'keyStoneVertical',
      'selectedModelData',
      'position'
    ]),
    ...mapGetters([
      'unitLabel'
    ]),
    vAngleFlagData () {
      return this.vAngleFlag
    },
    vAngleData: {
      get () {
        return this.vAngle
      },
      set (value) {
        this.$store.commit('SET_VANGLE', value)
      }
    },
    projectorCheckedSide: {
      get () {
        return this.projector_checked_side
      },
      set (value) {
        this.$store.commit('SET_PROJECTORCHECKEDSIDE', value)
      }
    },
    isVTypeThree () {
      return this.selectedModelData.lightType === 'Laser Diode'
    },
    isVTypeOne () {
      let value = false
      if (this.selectedModelData.lightType !== 'Lamp') {
        return value
      }
      for (let i = 0; i < this.vAngleTypeOneArr.length; i++) {
        if (this.selectedModelData.name.indexOf(this.vAngleTypeOneArr[i]) !== -1) {
          value = true
          break
        }
      }
      return value
    },
    isVTypeTwo () {
      return !this.isVTypeThree && !this.isVTypeOne
    },

    isVOutTypeOne () {
      let value = this.vAngleFlagData && this.isVTypeOne && !this.keyStoneVertical
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.$parent.isVAngleTypeOneOut = value
      return value
    },
    isVOutTypeTwo () {
      let value = this.vAngleFlagData && this.isVTypeTwo && Math.abs(this.vAngleData) > 30
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.$parent.isVAngleTypeTwoOut = value
      return value
    },
    isVOutTypeThree () {
      return this.vAngleFlagData && this.isVTypeThree && !this.keyStoneVertical
    },
    isVOut () {
      let value = this.isVOutTypeOne || this.isVOutTypeTwo || this.isVOutTypeThree
      this.$store.commit('SET_ISVANGLEOUT', value)
      return value
    }
  },
  created () {
    this.depthInit = this.houseInfo.roomD
    this.heightInit = this.houseInfo.roomH
  },
  mounted () {
    this.child = this.$refs.sideView
    this.sliderHeight = this.child.$refs.canvas_side.offsetHeight * 0.35 + 'px' // TODO
    this.vAngleDataSilder = this.vAngleData
    this.initCanvasData()
    this.$watch('drawData', function () {
      this.initCanvasData()
      this.$nextTick(function () {
        this.child.onGraphChanged()
      })
    }, { deep: true })
    this.$watch('graph', function () {
      this.initCanvasData()
      this.$nextTick(function () {
        this.child.onGraphChanged()
      })
    }, { deep: true })

    this.$watch('houseInfo', function () {
      this.initCanvasData()
      this.depthInit = this.houseInfo.roomD
      this.heightInit = this.houseInfo.roomH
      this.$nextTick(function () {
        this.child.onHouseInfoChanged()
      })
    }, { deep: true })
  },
  methods: {
    ...mapMutations([
      'SET_VANGLE'
    ]),
    initCanvasData () {
      if (!this.drawData) {
        return
      }
      this.isLShaped01 = this.$commonViewJs.isLShaped01()
      // 房间矩形边框
      this.roomRect = null
      // 连线
      this.arrRectLines = []
      // 镜头水平倾斜时出现的第二条屏幕延伸线数组
      this.arrRectHorSecLines = []
      // 虚线
      this.arrDashLines = []
      // 虚线
      this.arrDashRemainLines = []
      // Offset
      this.arrOffsetLines = []
      this.arrLightingArea = []
      // 投影仪可拖动区域
      this.avlRect = null
      // 辅助线
      this.arrHelpLines = []
      // 辅助线上尺寸大小
      this.arrHelpText = []
      // 斜边投影区域
      this.arrCatchArea = []

      this.setPjRect()
      this.setArrDashLines()
      this.setArrDashRemainLines()
      this.setArrOffsetLines()
      this.setRoomRect()
      this.setAvlRect()
      this.setArrCatchArea()
      this.setArrRectLines()
      this.setArrLightingArea()
      // this.setArrHelpLine()
      // this.setArrHelpText()
    },
    setPjRect () {
      var x = this.$commonViewJs.getAy()
      var y = this.$commonViewJs.getAz()
      var width = this.lenghProInit
      var height = this.widthProInit

      this.pjImgRect = this.$draw.toRect(x, y, width, height)
    },
    setRoomRect () {
      this.roomRect = this.$draw.toRect(
        0,
        0,
        this.houseInfo.roomD,
        this.houseInfo.roomH
      )
    },
    setAvlRect () {
      if (this.$commonViewJs.isAvlExist()) {
        var k, l
        if (this.isLShaped01) {
          k = this.$draw.toPoint(
            this.$commonViewJs.getLSMinY(),
            this.position === 1 ? this.$commonViewJs.getLSTH() : this.$commonViewJs.getLSWH()
          )
          l = this.$draw.toPoint(
            this.$commonViewJs.getLSMaxY(),
            this.position === 1 ? this.$commonViewJs.getLSWH() : this.$commonViewJs.getLSTH()
          )
        } else {
          k = this.$draw.toPoint(
            this.$commonViewJs.getKy(),
            this.$commonViewJs.getKz()
          )
          l = this.$draw.toPoint(
            this.$commonViewJs.getLy(),
            this.$commonViewJs.getLz()
          )
        }
        this.avlRect = this.$draw.toRect(
          k.x,
          k.y,
          l.x - k.x,
          l.y - k.y
        )
      }
    },
    setArrRectLines () {
      if (!this.drawData && !this.drawData[0]) {
        return
      }
      let data0 = this.drawData[0]
      let pjyPointX = this.$commonViewJs.getAy()
      let pjyPointY = this.$commonViewJs.getAz()
      for (let i = 0; i < data0.length; i++) {
        var rectLines = this.$draw.toLine(
          this.drawData[0][i].y,
          this.drawData[0][i].z,
          pjyPointX,
          pjyPointY,
          this.$constant.rectLineColor,
          0.8
        )
        this.arrRectLines.push(rectLines)
        // this.arrRectLines.push(this.$draw.toPoint(data0[i].y, data0[i].z))
      }
      // this.arrRectLines.push(this.$draw.toPoint(this.$commonViewJs.getAy(), this.graph.pjZ))
    },
    setArrLightingArea () {
      if (!this.drawData && !this.drawData[0]) {
        return
      }
      let data0 = this.drawData[0]
      let LightingPoints0 = []
      if (this.isLShaped01) {
        let data0 = this.drawData[2]
        for (let j = 0; j < data0.length; j++) {
          LightingPoints0.push(this.$draw.toPoint(data0[j].y, data0[j].z))
        }
        if (data0.length === 0) {
          for (let i = 0; i < this.drawData[0].length; i++) {
            LightingPoints0.push(this.$draw.toPoint(this.drawData[0][i].y, this.drawData[0][i].z))
          }
        }
        LightingPoints0.push(this.$draw.toPoint(this.$commonViewJs.getAy(), this.$commonViewJs.getAz()))
        this.arrLightingArea.push(LightingPoints0)
      } else {
        LightingPoints0.push(this.$draw.toPoint(data0[0].y, data0[0].z))
        if (!(data0[0].y - this.offset > this.limitData && data0[1].y - this.offset > this.limitData && data0[2].y - this.offset > this.limitData && data0[3].y - this.offset > this.limitData)) {
          if (data0[0].y - this.offset > this.limitData && data0[0].z < this.limitData) {
            if (data0[3].y - this.offset < this.limitData || (data0[3].y - this.offset > this.limitData && data0[3].z > this.limitData)) {
              LightingPoints0.push(this.$draw.toPoint(this.offset, 0))
            }
          }
          if (data0[3].y - this.offset > this.limitData && (this.houseInfo.roomH - data0[3].z) < this.limitData) {
            if (data0[0].y - this.offset < this.limitData || (data0[0].y - this.offset > this.limitData && (this.houseInfo.roomH - data0[0].z) > this.limitData)) {
              LightingPoints0.push(this.$draw.toPoint(this.offset, this.houseInfo.roomH))
            }
          }
        }
        LightingPoints0.push(this.$draw.toPoint(data0[3].y, data0[3].z))
        LightingPoints0.push(this.$draw.toPoint(this.$commonViewJs.getAy(), this.$commonViewJs.getAz()))
        this.arrLightingArea.push(LightingPoints0)

        let LightingPoints1 = []
        LightingPoints1.push(this.$draw.toPoint(data0[1].y, data0[1].z))
        // if (Number(data0[1].y) > this.limitData && Number(data0[1].y) < this.limitData) {
        //   LightingPoints0.push(this.$draw.toPoint(0, 0))
        // }
        LightingPoints1.push(this.$draw.toPoint(data0[2].y, data0[2].z))
        LightingPoints1.push(this.$draw.toPoint(this.$commonViewJs.getAy(), this.$commonViewJs.getAz()))
        this.arrLightingArea.push(LightingPoints1)
      }
    },
    setArrCatchArea () {
      if (!this.drawData) {
        return
      }
      for (let i = 1; i < this.drawData.length; i++) {
        for (let j = 0; j < this.drawData[i].length; j++) {
          this.arrCatchArea.push(this.$draw.toPoint(this.drawData[i][j].y, this.drawData[i][j].z))
        }
      }
    },
    setArrDashLines () {
      if (this.isLShaped01) {
        // 可移动区域的虚线
        if (this.$commonViewJs.isAvlExist()) {
          let pointW = this.$commonViewJs.getLSWH()
          let pointT = this.$commonViewJs.getLSTH()
          let pointRD = this.$commonViewJs.getEy()
          this.arrDashLines.push(this.$draw.toLine(0, pointW, pointRD, pointW))
          this.arrDashLines.push(this.$draw.toLine(0, pointT, pointRD, pointT))
        }
        // 投影仪中心的虚线
        let pointPY = this.$commonViewJs.getDy()
        let pointRH = this.$commonViewJs.getFz()
        this.arrDashLines.push(this.$draw.toLine(pointPY, 0, pointPY, pointRH))
      } else {
        var dashLine0 = this.$draw.toLine(
          0,
          this.$commonViewJs.getGz(),
          this.$commonViewJs.getEy(),
          this.$commonViewJs.getEz()
        )
        this.arrDashLines.push(dashLine0)
        var dashLine1 = this.$draw.toLine(
          this.$commonViewJs.getKy(),
          0,
          this.$commonViewJs.getKy(),
          this.$commonViewJs.getFz()
        )
        this.arrDashLines.push(dashLine1)
        if (this.$commonViewJs.isAvlExist()) {
          var dashLine2 = this.$draw.toLine(
            this.$commonViewJs.getLy(),
            0,
            this.$commonViewJs.getLy(),
            this.$commonViewJs.getFz()
          )
          this.arrDashLines.push(dashLine2)
        }
      }
    },
    setArrDashRemainLines () {
      // 屏幕锁定在点击倾斜角度时，获取的屏幕虚线
      var dashLine1
      if (this.dashFlag) {
        for (let i = 1; i < this.dashData.length; i++) {
          for (let j = 1; j < this.dashData[i].length; j++) {
            dashLine1 = this.$draw.toLine(this.dashData[i][j - 1].y, this.dashData[i][j - 1].z, this.dashData[i][j].y, this.dashData[i][j].z, '#000000', 2)
            this.arrDashRemainLines.push(dashLine1)
          }
          if (i === this.dashData.length - 1) {
            dashLine1 = this.$draw.toLine(this.dashData[i][this.dashData[i].length - 1].y, this.dashData[i][this.dashData[i].length - 1].z, this.dashData[1][0].y, this.dashData[1][0].z, '#000000', 2)
            this.arrDashRemainLines.push(dashLine1)
          } else {
            dashLine1 = this.$draw.toLine(this.dashData[i][this.dashData[i].length - 1].y, this.dashData[i][this.dashData[i].length - 1].z, this.dashData[i + 1][0].y, this.dashData[i + 1][0].z, '#000000', 2)
            this.arrDashRemainLines.push(dashLine1)
          }
        }
      }
    },
    setArrOffsetLines () {
      if (this.$commonViewJs.isOffsetExist()) {
        let dashLine
        let pointRH = this.$commonViewJs.getFz()
        let pointRD = this.$commonViewJs.getEy()
        if (this.isLShaped01) {
          let pointY = this.position === 1 ? pointRH - this.offset : this.offset
          dashLine = this.$draw.toLine(0, pointY, pointRD, pointY, this.$constant.dashLineColor, 1.2)
        } else {
          dashLine = this.$draw.toLine(this.offset, 0, this.offset, pointRH, this.$constant.dashLineColor, 1.2)
        }
        this.arrOffsetLines.push(dashLine)
      }
    },
    setArrHelpLine (proportion) {
      // 上辅助线
      this.helpDisMin = 10 * proportion
      this.helpDisMax = 18 * proportion
      this.helpTextDis = 20 * proportion
      this.helpBesideDis = 10 * proportion
      this.arrHelpLines.splice(0, this.arrHelpLines.length)
      this.arrHelpText.splice(0, this.arrHelpText.length)

      if (this.isLShaped01) {
        this.setArrHelpLineLShaped(proportion)
        return
      }

      var helpLine0 = this.$draw.toLine(
        0,
        0 - this.helpDisMin,
        0,
        0 - this.helpDisMax,
        this.$constant.helpLineColor,
        0.8
      )
      this.arrHelpLines.push(helpLine0)
      if (this.$commonViewJs.isOffsetExist()) {
        helpLine0 = this.$draw.toLine(
          this.offset,
          0 - this.helpDisMin,
          this.offset,
          0 - this.helpDisMax,
          this.$constant.helpLineColor,
          0.8
        )
        this.arrHelpLines.push(helpLine0)
      }
      var helpLine1 = this.$draw.toLine(
        this.$commonViewJs.getAy(),
        0 - this.helpDisMin,
        this.$commonViewJs.getAy(),
        0 - this.helpDisMax,
        this.$constant.helpLineColor,
        0.8
      )
      this.arrHelpLines.push(helpLine1)
      var helpLine2 = this.$draw.toLine(
        0,
        0 - (this.helpDisMax + this.helpDisMin) / 2,
        this.houseInfo.roomD > this.$commonViewJs.getAy() ? this.houseInfo.roomD : this.$commonViewJs.getAy(),
        0 - (this.helpDisMax + this.helpDisMin) / 2,
        this.$constant.helpLineColor,
        0.8
      )
      this.arrHelpLines.push(helpLine2)

      var helpLine3 = this.$draw.toLine(
        this.houseInfo.roomD,
        0 - this.helpDisMin,
        this.houseInfo.roomD,
        0 - this.helpDisMax,
        this.$constant.helpLineColor,
        0.8
      )
      this.arrHelpLines.push(helpLine3)
      // 右辅助线
      var helpLine5 = this.$draw.toLine(
        this.houseInfo.roomD + this.helpDisMin,
        0,
        this.houseInfo.roomD + this.helpDisMax,
        0,
        this.$constant.helpLineColor,
        0.8
      )
      this.arrHelpLines.push(helpLine5)
      var helpLine6 = this.$draw.toLine(
        this.houseInfo.roomD + this.helpDisMin,
        this.$commonViewJs.getAz(),
        this.houseInfo.roomD + this.helpDisMax,
        this.$commonViewJs.getAz(),
        this.$constant.helpLineColor,
        0.8
      )
      this.arrHelpLines.push(helpLine6)
      var helpLine7 = this.$draw.toLine(
        this.houseInfo.roomD + (this.helpDisMin + this.helpDisMax) / 2,
        0,
        this.houseInfo.roomD + (this.helpDisMin + this.helpDisMax) / 2,
        this.houseInfo.roomH,
        this.$constant.helpLineColor,
        0.8
      )
      this.arrHelpLines.push(helpLine7)
      var helpLine8 = this.$draw.toLine(
        this.houseInfo.roomD + this.helpDisMin,
        this.houseInfo.roomH,
        this.houseInfo.roomD + this.helpDisMax,
        this.houseInfo.roomH,
        this.$constant.helpLineColor,
        0.8
      )
      this.arrHelpLines.push(helpLine8)
      // 下辅助线
      if (this.$commonViewJs.isAvlExist()) {
        var helpLine9 = this.$draw.toLine(
          this.$commonViewJs.getKy(),
          this.houseInfo.roomH + this.helpDisMin,
          this.$commonViewJs.getKy(),
          this.houseInfo.roomH + this.helpDisMax,
          this.$constant.helpLineColor,
          0.8
        )
        this.arrHelpLines.push(helpLine9)
        var helpLine10 = this.$draw.toLine(
          this.$commonViewJs.getLy(),
          this.houseInfo.roomH + this.helpDisMin,
          this.$commonViewJs.getLy(),
          this.houseInfo.roomH + this.helpDisMax,
          this.$constant.helpLineColor,
          0.8
        )
        this.arrHelpLines.push(helpLine10)
        var helpLine11 = this.$draw.toLine(
          this.$commonViewJs.getKy(),
          this.houseInfo.roomH + (this.helpDisMin + this.helpDisMax) / 2,
          this.$commonViewJs.getLy(),
          this.houseInfo.roomH + (this.helpDisMin + this.helpDisMax) / 2,
          this.$constant.helpLineColor,
          0.8
        )
        this.arrHelpLines.push(helpLine11)
      }
      // 左辅助线
      var helpLineLeft = this.$draw.toLine(
        0 - this.helpDisMin,
        0,
        0 - this.helpDisMax,
        0,
        this.$constant.helpLineColor,
        0.8
      )
      this.arrHelpLines.push(helpLineLeft)
      let mp = this.getPointMaxAndMin()
      helpLineLeft = this.$draw.toLine(
        0 - this.helpDisMin,
        mp.minP.z,
        0 - this.helpDisMax,
        mp.minP.z,
        this.$constant.helpLineColor,
        0.8
      )
      this.arrHelpLines.push(helpLineLeft)
      helpLineLeft = this.$draw.toLine(
        0 - this.helpDisMin,
        mp.maxP.z,
        0 - this.helpDisMax,
        mp.maxP.z,
        this.$constant.helpLineColor,
        0.8
      )
      this.arrHelpLines.push(helpLineLeft)
      helpLineLeft = this.$draw.toLine(
        0 - this.helpDisMin,
        this.houseInfo.roomH,
        0 - this.helpDisMax,
        this.houseInfo.roomH,
        this.$constant.helpLineColor,
        0.8
      )
      this.arrHelpLines.push(helpLineLeft)
      helpLineLeft = this.$draw.toLine(
        0 - (this.helpDisMin + this.helpDisMax) / 2,
        0,
        0 - (this.helpDisMin + this.helpDisMax) / 2,
        this.houseInfo.roomH,
        this.$constant.helpLineColor,
        0.8
      )
      this.arrHelpLines.push(helpLineLeft)

      this.setArrHelpText(proportion, mp)
    },
    setArrHelpLineLShaped (proportion) {
      // 左边的辅助线
      let pointX1 = 0 - this.helpDisMin
      let pointX2 = 0 - this.helpDisMax
      let pointX3 = 0 - (this.helpDisMax + this.helpDisMin) / 2
      let pointY1 = 0
      let pointY2 = this.position === 1 ? this.houseInfo.roomH - this.offset : this.offset
      let pointY3 = this.$commonViewJs.getAz()
      let pointY4 = this.houseInfo.roomH
      // 左边的横线
      let leftPoint = [{ x1: pointX1, y1: pointY1, x2: pointX2, y2: pointY1 }]
      if (this.$commonViewJs.isOffsetExist()) {
        leftPoint.push({ x1: pointX1, y1: pointY2, x2: pointX2, y2: pointY2 })
      }
      leftPoint.push({ x1: pointX1, y1: pointY3, x2: pointX2, y2: pointY3 })
      leftPoint.push({ x1: pointX1, y1: pointY4, x2: pointX2, y2: pointY4 })
      // 左边的竖线
      leftPoint.push({ x1: pointX3, y1: pointY1, x2: pointX3, y2: Math.max(pointY3, pointY4) })
      let leftHelpLine
      leftPoint.forEach(item => {
        leftHelpLine = this.$draw.toLine(item.x1, item.y1, item.x2, item.y2, this.$constant.helpLineColor, 0.8)
        this.arrHelpLines.push(leftHelpLine)
      })

      // 下边的辅助线(桌面), 上边的辅助线(吊顶)
      pointX1 = 0
      pointX2 = this.$commonViewJs.getAy()
      pointX3 = this.houseInfo.roomD
      pointY1 = this.position === 1 ? 0 - this.helpDisMin : this.houseInfo.roomH + this.helpDisMin
      pointY2 = this.position === 1 ? 0 - this.helpDisMax : this.houseInfo.roomH + this.helpDisMax
      pointY3 = this.position === 1 ? 0 - (this.helpDisMin + this.helpDisMax) / 2 : this.houseInfo.roomH + (this.helpDisMin + this.helpDisMax) / 2
      // 下边的竖线
      let bottomPoint = []
      bottomPoint.push({ x1: pointX1, y1: pointY1, x2: pointX1, y2: pointY2 })
      bottomPoint.push({ x1: pointX2, y1: pointY1, x2: pointX2, y2: pointY2 })
      bottomPoint.push({ x1: pointX3, y1: pointY1, x2: pointX3, y2: pointY2 })
      // 下边的横线
      bottomPoint.push({ x1: pointX1, y1: pointY3, x2: pointX3, y2: pointY3 })
      let bottomHelpLine
      bottomPoint.forEach(item => {
        bottomHelpLine = this.$draw.toLine(item.x1, item.y1, item.x2, item.y2, this.$constant.helpLineColor, 0.8)
        this.arrHelpLines.push(bottomHelpLine)
      })

      // 右边的辅助线(可移动区域)
      if (this.$commonViewJs.isAvlExist()) {
        pointX1 = this.houseInfo.roomD + this.helpDisMin
        pointX2 = this.houseInfo.roomD + this.helpDisMax
        pointX3 = this.houseInfo.roomD + (this.helpDisMin + this.helpDisMax) / 2
        pointY1 = this.position === 1 ? this.houseInfo.roomH - this.$commonViewJs.getKy() : this.$commonViewJs.getKy()
        pointY2 = this.position === 1 ? this.houseInfo.roomH - this.$commonViewJs.getLy() : this.$commonViewJs.getLy()
        let rightPoint = [
          { x1: pointX1, y1: pointY1, x2: pointX2, y2: pointY1 },
          { x1: pointX1, y1: pointY2, x2: pointX2, y2: pointY2 },
          { x1: pointX3, y1: pointY1, x2: pointX3, y2: pointY2 }
        ]
        let rightHelpLine
        rightPoint.forEach(item => {
          rightHelpLine = this.$draw.toLine(item.x1, item.y1, item.x2, item.y2, this.$constant.helpLineColor, 0.8)
          this.arrHelpLines.push(rightHelpLine)
        })
      }

      // 上边的辅助线(桌面), 下边的辅助线(吊顶)
      let mp = this.getPointCurMaxAndMin()
      if (!mp.minP || !mp.maxP) return
      pointX1 = 0
      pointX2 = mp.minP.y
      pointX3 = mp.maxP.y
      let pointX4 = this.houseInfo.roomD
      pointY1 = this.position === 1 ? this.houseInfo.roomH + this.helpDisMin : 0 - this.helpDisMin
      pointY2 = this.position === 1 ? this.houseInfo.roomH + this.helpDisMax : 0 - this.helpDisMax
      pointY3 = this.position === 1 ? this.houseInfo.roomH + (this.helpDisMin + this.helpDisMax) / 2 : 0 - (this.helpDisMin + this.helpDisMax) / 2
      let topPoint = []
      // 上边的竖线
      topPoint.push({ x1: pointX1, y1: pointY1, x2: pointX1, y2: pointY2 })
      topPoint.push({ x1: pointX2, y1: pointY1, x2: pointX2, y2: pointY2 })
      topPoint.push({ x1: pointX3, y1: pointY1, x2: pointX3, y2: pointY2 })
      topPoint.push({ x1: pointX4, y1: pointY1, x2: pointX4, y2: pointY2 })
      // 上边的横线
      topPoint.push({ x1: pointX1, y1: pointY3, x2: pointX4, y2: pointY3 })
      let topHelpLine
      topPoint.forEach(item => {
        topHelpLine = this.$draw.toLine(item.x1, item.y1, item.x2, item.y2, this.$constant.helpLineColor, 0.8)
        this.arrHelpLines.push(topHelpLine)
      })

      this.setArrHelpTextLShaped(proportion, mp)
    },
    // 获取z轴坐标在主墙上的最大值最小值，因为数据存在误差，判断当数据x最大时，取最大值的z为this.houseInfo.roomW的点
    getPointMaxAndMin () {
      let maxFlag = false
      let minFlag = false
      let outFlag = true
      let initDMax = this.drawData[1][0]
      let initDMin = this.drawData[1][0]
      for (let i = 0; i < this.drawData[0].length; i++) {
        if (this.drawData[0][i].y - this.offset < this.limitData) {
          outFlag = false
        }
      }
      if (outFlag) {
        return {
          maxP: { x: 0, y: 0, z: this.houseInfo.roomH },
          minP: { x: 0, y: 0, z: 0 }
        }
      }
      for (let i = 1; i < this.drawData.length; i++) {
        for (let j = 0; j < this.drawData[i].length; j++) {
          if (Math.abs(this.drawData[i][j].z - this.houseInfo.roomH) < this.limitData && !maxFlag) {
            maxFlag = true
            initDMax = this.drawData[i][j]
          } else if (this.drawData[i][j].z < this.limitData && !minFlag) {
            minFlag = true
            initDMin = this.drawData[i][j]
          } else if (this.drawData[i][j].y - this.offset < this.limitData) {
            if (this.drawData[i][j].z > initDMax.z && !maxFlag) {
              initDMax = this.drawData[i][j]
            }
            if (this.drawData[i][j].z < initDMin.z && !minFlag) {
              initDMin = this.drawData[i][j]
            }
          }
        }
      }
      return {
        maxP: initDMax,
        minP: initDMin
      }
    },
    getPointCurMaxAndMin () {
      let initDMax, initDMin
      for (let i = 1; i < this.drawData.length; i++) {
        if (this.drawData[i].length > 0) {
          initDMax = this.drawData[i][0]
          initDMin = this.drawData[i][0]
          break
        }
      }
      let param = this.isLShaped01 ? 'y' : 'z'
      for (let i = 1; i < this.drawData.length; i++) {
        for (let j = 0; j < this.drawData[i].length; j++) {
          if (this.drawData[i][j][param] > initDMax[param]) {
            initDMax = this.drawData[i][j]
          }
          if (this.drawData[i][j][param] < initDMin[param]) {
            initDMin = this.drawData[i][j]
          }
        }
      }
      return {
        maxP: initDMax,
        minP: initDMin
      }
    },
    setArrHelpText (value, mp) {
      let bs = 10 * value
      let lis = 7 * value
      // 上
      if (this.$commonViewJs.isOffsetExist()) {
        var textName0 = this.$commonJs.changeUnitDraw(this.offset, this.graph.unit, false)
        var helpText0 = this.$draw.toText(
          this.offset / 2,
          0 - this.helpTextDis,
          textName0,
          'top'
        )
        this.arrHelpText.push(helpText0)
      }
      textName0 = this.$commonJs.changeUnitDraw(this.graph.pjY, this.graph.unit, false)
      helpText0 = this.$draw.toText(
        this.graph.pjY / 2 + this.offset,
        0 - this.helpTextDis,
        textName0,
        'top'
      )
      this.arrHelpText.push(helpText0)

      var textName1 = this.$commonJs.changeUnitDraw(
        this.houseInfo.roomD - this.$commonViewJs.getAy(), this.graph.unit, false
      )
      var helpText1 = this.$draw.toText(
        (this.houseInfo.roomD + this.$commonViewJs.getAy()) / 2,
        0 - this.helpTextDis,
        textName1,
        'top'
      )
      this.arrHelpText.push(helpText1)

      // 右边标注的尺寸被覆盖，所以需要调整
      let rightMov = this.graph.unit === 'T_FEET_FRACTION' ? 60 : 0
      var textName2 = this.$commonJs.changeUnitDraw(this.$commonViewJs.getAz(), this.graph.unit, false)
      var helpText2 = this.$draw.toText(
        this.houseInfo.roomD + this.helpTextDis + this.helpBesideDis - rightMov,
        this.$commonViewJs.getAz() / 2 + lis,
        textName2,
        'right'
      )
      this.arrHelpText.push(helpText2)

      var textName3 = this.$commonJs.changeUnitDraw(
        this.houseInfo.roomH - this.$commonViewJs.getAz(), this.graph.unit, false
      )
      var helpText3 = this.$draw.toText(
        this.houseInfo.roomD + this.helpTextDis + this.helpBesideDis - rightMov,
        (this.$commonViewJs.getAz() + this.houseInfo.roomH) / 2 + lis,
        textName3,
        'right'
      )
      this.arrHelpText.push(helpText3)
      // 下辅助线的文字
      if (this.$commonViewJs.isAvlExist()) {
        var textName4 = this.$commonJs.changeUnitDraw(
          this.$commonViewJs.getLy() - this.$commonViewJs.getKy(), this.graph.unit, false
        )
        var helpText4 = this.$draw.toText(
          (this.$commonViewJs.getLy() + this.$commonViewJs.getKy()) / 2,
          this.houseInfo.roomH + this.helpTextDis + bs,
          textName4,
          'bottom'
        )
        this.arrHelpText.push(helpText4)
      }
      // 单位
      var textName5 = '(' + this.unitLabel + ')'
      var helpText5 = this.$draw.toText(
        this.houseInfo.roomD + this.helpTextDis + this.helpBesideDis,
        0 - this.helpTextDis,
        textName5,
        'top'
      )
      this.arrHelpText.push(helpText5)
      // 左辅助线
      // 左边标注的尺寸被覆盖，所以需要调整
      let leftMov = this.graph.unit === 'T_FEET_FRACTION' ? 60 : 0
      var textNameLeft = this.$commonJs.changeUnitDraw(
        mp.minP.z, this.graph.unit, false
      )
      var helpTextLeft = this.$draw.toText(
        0 - this.helpTextDis - this.helpBesideDis + leftMov,
        mp.minP.z / 2 + lis,
        textNameLeft,
        'left'
      )
      this.arrHelpText.push(helpTextLeft)
      textNameLeft = this.$commonJs.changeUnitDraw(
        mp.maxP.z - mp.minP.z, this.graph.unit, false
      )
      helpTextLeft = this.$draw.toText(
        0 - this.helpTextDis - this.helpBesideDis + leftMov,
        (mp.maxP.z + mp.minP.z) / 2 + lis,
        textNameLeft,
        'left'
      )
      this.arrHelpText.push(helpTextLeft)
      textNameLeft = this.$commonJs.changeUnitDraw(
        this.houseInfo.roomH - mp.maxP.z, this.graph.unit, false
      )
      helpTextLeft = this.$draw.toText(
        0 - this.helpTextDis - this.helpBesideDis + leftMov,
        (this.houseInfo.roomH + mp.maxP.z) / 2 + lis,
        textNameLeft,
        'left'
      )
      this.arrHelpText.push(helpTextLeft)
    },
    setArrHelpTextLShaped (value, mp) {
      let bs = 10 * value
      let lis = 7 * value

      // 左边的辅助文字
      let leftText, leftHelpText
      let leftTextInfo = []
      let leftMov = this.graph.unit === 'T_FEET_FRACTION' ? 60 : 0
      let dist = this.$commonViewJs.getLshapedDist()
      let pointX1 = 0 - this.helpTextDis - this.helpBesideDis + leftMov
      let pointY1 = this.position === 1 ? this.houseInfo.roomH - this.offset / 2 : this.offset / 2
      let pointY2 = this.position === 1 ? this.$commonViewJs.getAz() + dist / 2 : this.graph.pjZ / 2 + this.offset
      let pointY3 = this.position === 1 ? this.$commonViewJs.getAz() / 2 : (this.houseInfo.roomH + this.$commonViewJs.getAz()) / 2
      if (this.$commonViewJs.isOffsetExist()) {
        leftTextInfo.push({ text: this.offset, x: pointX1, y: pointY1 + lis })
      }
      leftTextInfo.push({ text: dist, x: pointX1, y: pointY2 + lis })
      leftText = this.position === 1 ? this.$commonViewJs.getAz() : this.houseInfo.roomH - this.$commonViewJs.getAz()
      leftTextInfo.push({ text: leftText, x: pointX1, y: pointY3 + lis })
      if (this.position === 1) leftTextInfo.reverse() // 适应文本重叠处理
      leftTextInfo.forEach(item => {
        leftText = this.$commonJs.changeUnitDraw(item.text, this.graph.unit, false)
        leftHelpText = this.$draw.toText(item.x, item.y, leftText, 'left')
        this.arrHelpText.push(leftHelpText)
      })

      // 右辅助文字
      if (this.$commonViewJs.isAvlExist()) {
        let rightMov = this.graph.unit === 'T_FEET_FRACTION' ? 60 : 0
        let rightText = this.$commonJs.changeUnitDraw(this.$commonViewJs.getLy() - this.$commonViewJs.getKy(), this.graph.unit, false)
        pointX1 = this.houseInfo.roomD + this.helpTextDis + this.helpBesideDis - rightMov
        pointY1 = (this.$commonViewJs.getLy() + this.$commonViewJs.getKy()) / 2 + lis
        this.arrHelpText.push(this.$draw.toText(pointX1, pointY1, rightText, 'right'))
      }

      // 下边的辅助文字(桌面), 上边的辅助文字(吊顶)
      let bottomText, bottomHelpText, bottomTextInfo, pointX2
      let cvPos = this.position === 1 ? 'top' : 'bottom'
      pointY1 = this.position === 1 ? 0 - this.helpTextDis : this.houseInfo.roomH + this.helpTextDis + bs
      pointX1 = this.$commonViewJs.getAy() / 2
      pointX2 = (this.$commonViewJs.getAy() + this.houseInfo.roomD) / 2
      bottomTextInfo = [
        { text: this.$commonViewJs.getAy(), x: pointX1, y: pointY1 },
        { text: this.houseInfo.roomD - this.$commonViewJs.getAy(), x: pointX2, y: pointY1 }
      ]
      bottomTextInfo.forEach(item => {
        bottomText = this.$commonJs.changeUnitDraw(item.text, this.graph.unit, false)
        bottomHelpText = this.$draw.toText(item.x, item.y, bottomText, cvPos)
        this.arrHelpText.push(bottomHelpText)
      })

      // 单位
      this.arrHelpText.push(this.$draw.toText(this.depthInit + this.helpTextDis + this.helpBesideDis, 0 - this.helpTextDis, '(' + this.unitLabel + ')', 'top'))

      // 上边的辅助文字(桌面), 下边的辅助文字(吊顶)
      if (!mp.minP || !mp.maxP) return
      let topText, topHelpText, topTextInfo, pointX3
      cvPos = this.position === 0 ? 'top' : 'bottom'
      pointY1 = this.position === 0 ? 0 - this.helpTextDis : this.houseInfo.roomH + this.helpTextDis + bs
      pointX1 = mp.minP.y / 2
      pointX2 = (mp.maxP.y + mp.minP.y) / 2
      pointX3 = (this.houseInfo.roomD + mp.maxP.y) / 2
      topTextInfo = [
        { text: mp.minP.y, x: pointX1, y: pointY1 },
        { text: mp.maxP.y - mp.minP.y, x: pointX2, y: pointY1 },
        { text: this.houseInfo.roomD - mp.maxP.y, x: pointX3, y: pointY1 }
      ]
      topTextInfo.forEach(item => {
        topText = this.$commonJs.changeUnitDraw(item.text, this.graph.unit, false)
        topHelpText = this.$draw.toText(item.x, item.y, topText, cvPos)
        this.arrHelpText.push(topHelpText)
      })
    },

    onResize () {
      // TODO set conponent size
      this.sliderHeight = this.child.$refs.canvas_side.offsetHeight * 0.35 + 'px'
      this.child.resizeDraw()
    },
    // 校验不为空
    validator (e) {
      if (e.target.value === '') {
        this.$toast('必填')
        e.target.focus()
      }
    },
    testDigitalNegative (e, key) {
      e = e.replace(/[^(\-|+)0-9|.]/ig, '')
      let tempArray = e.split('.')
      this.vAngleDataSilder = e
      if (e && e !== '-' && ((tempArray.length > 1 && tempArray[1]) || tempArray.length === 1)) {
        this.vAngleDataSilder = (e * 1).toFixed(1) * 1
        this[key] = (e * 1).toFixed(1) * 1
      }
    }
  },

  watch: {
    vAngleData (newValue) {
      this.vAngleDataSilder = newValue
    }
  }
}
</script>

<style scoped>
.side-view {
  height: 100%;
  width: 100%;
  border-left: none;
  border-right: none;
  border-bottom: none;
  position: relative;
  overflow: hidden;
  /* border-right: 1px solid #bdbdbd; */
}
.horizontal {
  font-size: 12px;
  float: right;
  margin: -15px 5px 0px 0px;
}
.inline {
  width: 300px;
  height: 44px;
  border: 1px solid #e3e3e3;
  margin-left: 50px;
  margin-top: -55px;
}
.side-img {
  background: url('../../assets/parts/icon/icon_side.png') no-repeat center;
  width: 30px;
  height: 30px;
  float: left;
}
</style>
